<template>
  <div>
    <h1 class="page-title text-left">Larvicide Details</h1>
    <div class="panel">
      <div class="panel-heading">
        <h3 class="panel-title">
          Details
          <router-link :to="{ name: 'data-larvicide' }" class="pull-right ml-10"><i class="fa fa-list"></i></router-link>
          <i class="fa fa-pencil pointer pull-right" v-on:click="form.showEdit({id: id, list: true})"></i>
        </h3>
      </div>
      <div class="panel-body">
        <dl class="dl-horizontal">

          <dt>Larval Site</dt>
          <dd><router-link :to="{ name: 'data-larval-site-details', params: {id: form.data.larvalSiteId} }">{{ form.data.larvalSiteName }}</router-link></dd>

          <dt>Date</dt>
          <dd>{{ form.data.appliedDate | date }}</dd>

          <dt>Time</dt>
          <dd>{{ form.data.appliedTime | time }}</dd>

          <dt>Applicator</dt>
          <dd>{{ applicatorName(form.data.applicatorId) }}</dd>

          <dt>License</dt>
          <dd>{{ form.data.licenseNumber }}</dd>

          <dt>Temperature</dt>
          <dd>{{ form.data.temperature }}</dd>

          <dt>Wind Speed</dt>
          <dd>{{ form.data.windSpeed }}</dd>

          <dt>Wind Direction</dt>
          <dd>{{ windDirection(form.data.windDirectionId) }}</dd>

          <dt>Equipment Used</dt>
          <dd>{{ equipmentName(form.data.lequipmentId) }}</dd>

          <dt>Eggs</dt>
          <dd>{{ larvaCountName(form.data.eggs) }}</dd>

          <dt>Larvae</dt>
          <dd>{{ larvaCountName(form.data.larvae) }}</dd>

          <dt>Pupae</dt>
          <dd>{{ larvaCountName(form.data.pupae) }}</dd>

          <dt>Adults</dt>
          <dd>{{ larvaCountName(form.data.adults) }}</dd>

          <dt>Visual Monitoring</dt>
          <dd><i class="fa" :class="{ 'fa-check-square-o': form.data.vizualMonitorPerformed, 'fa-square-o': !form.data.vizualMonitorPerformed}"></i></dd>

          <dt>Control Action</dt>
          <dd>{{ controlAction(form.data.controlActionId) }}</dd>

          <dt>Chemical</dt>
          <dd>{{ chemicalName(form.data.lchemicalId) }}</dd>

          <dt>EPA Reg No.</dt>
          <dd>{{ form.data.epaRegNumber }}</dd>

          <dt>Amount (oz)</dt>
          <dd>{{ form.data.amount }}</dd>

          <dt>Appl. Rate</dt>
          <dd>{{ applicationRate(form.data.applicationRate) }}</dd>

          <dt>Area Treated (sq. ft.)</dt>
          <dd>{{ form.data.areaTreated }}</dd>

          <dt>Sample Number</dt>
          <dd>{{ form.data.sampleNumber }}</dd>

          <dt>Wet/Dry</dt>
          <dd>{{ form.data.wetDry }}</dd>

          <dt>Predators</dt>
          <dd><i class="fa" :class="{ 'fa-check-square-o': form.data.predators, 'fa-square-o': !form.data.predators}"></i></dd>

          <dt>Biting Activity</dt>
          <dd><i class="fa" :class="{ 'fa-check-square-o': form.data.bitingActivity, 'fa-square-o': !form.data.bitingActivity}"></i></dd>

          <dt>Site Conditions</dt>
          <dd>{{ form.data.siteConditions }}</dd>

          <dt>Larval Stages</dt>
          <dd>{{ form.data.lStages }}</dd>

          <dt>% Breeding</dt>
          <dd>{{ form.data.percentBreeding }}</dd>

          <dt>% Culex</dt>
          <dd>{{ form.data.percentCulex }}</dd>

          <dt>% Non Culex</dt>
          <dd>{{ form.data.percentNonCulex }}</dd>

          <div v-if="form.data.serviceRequestId">
            <dt>Service Request</dt>
            <dd><router-link v-if="form.data.serviceRequestId" :to="{ name: 'data-service-request-details', params: {id: form.data.serviceRequestId} }">view</router-link></dd>

            <dt>Start Time</dt>
            <dd>{{ form.data.startTime | time }}</dd>

            <dt>End Time</dt>
            <dd>{{ form.data.endTime | time }}</dd>

            <dt>Habitat</dt>
            <dd>{{ habitatName(form.data.habitatId) }}</dd>
          </div>

          <dt>Work Status</dt>
          <dd>{{ form.data.workStatus }}</dd>

        </dl>

        <div>

          <!-- Nav tabs -->
          <ul class="nav nav-tabs" role="tablist">
            <li role="presentation" class="active"><a href="#larval" role="tab" data-toggle="tab">Larval Identification</a></li>
          </ul>

          <!-- Tab panes -->
          <div class="tab-content">
            <div role="tabpanel" class="tab-pane active" id="larval">

              <router-link :to="{ name: 'data-larval-identification-with-l', params: { id: id } }" class="btn btn-primary pull-right">Add larval identification</router-link>

              <table class="table table-striped">
                <thead>
                <tr>
                  <th>ID Date</th>
                  <th>Identified By</th>
                  <th>Species</th>
                  <th width="120"></th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="larval in form.data.larvalIdentifications">
                  <td>{{ larval.idDate | date }}</td>
                  <td>{{ larval.identifiedBy }}</td>
                  <td>
                    <div v-for="count in larval.species">
                      {{ mosquitoName(count.mosquito) }} : {{ count.count }}
                    </div>
                  </td>
                  <td>
                    <router-link :to="{ name: 'data-larval-identification-details', params: { id: larval.id }}"><i class="fa fa-ellipsis-h" style="margin-right: 10px;"></i></router-link>
                  </td>
                </tr>
                </tbody>
              </table>

            </div>

          </div>

        </div>

      </div>
    </div>

    <site-form :form="form"></site-form>


  </div>
</template>

<script>
  import LarvicidesService from '@/services/LarvicidesService';
  import Form from '@/utils/form';
  import loader from '@/utils/loader';
  import siteForm from '@/components/forms/larvicide';

  import store from '@/store';

  export default {
    name: 'larvicide_details',

    components: {
      siteForm
    },

    props: ['id'],

    data() {
      return {
        form: new Form(
          LarvicidesService,
          {
          })
      }
    },

    methods: {
      contractName(id) {
        return this.$store.getters.contractNameById(id);
      },
      applicatorName(id) {
        return this.$store.getters.applicatorNameById(id);
      },
      windDirection(id) {
        return this.$store.getters.windDirectionNameById(id);
      },
      equipmentName(id) {
        return this.$store.getters.lEquipementNameById(id);
      },
      vizualMonitor(id) {
        return this.$store.getters.vizualMonitorNameById(id)
      },
      controlAction(id) {
        return this.$store.getters.controlActionNameById(id)
      },
      chemicalName(id) {
        return this.$store.getters.lChemicalNameById(id)
      },
      larvaCountName(id) {
        return this.$store.getters.larvaCountNameById(id)
      },
      mosquitoName(id) {
        return this.$store.getters.mosquitoNameById(id)
      },
      habitatName(id) {
        return this.$store.getters.habitatNameById(id);
      },
      applicationRate(id) {
        return this.$store.getters.larvalAppRateNameById(id)
      },
    },

    mounted() {

      loader.lookups()
        .then(() => {
          this.form.getDetails(this.id)
            .then(() => {
              this.form.siteSearch.term = this.form.data.larvalSiteName;
              this.form.onSiteSearch('larvalSiteId');
            });
        });


    }

  }
</script>

<style lang="scss">

</style>
